import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from "@angular/router";
import { ShopService } from '../../../services/shop.service';
import { TerminalsService } from '../../../services/terminals.service';
import { ActionsBase } from './actions-base.model';

@Component({
    selector: 'terminals-actions',
    templateUrl: './actions-data.component.html',
    styleUrls: ['../navtrail.component.scss'],
    standalone: false
})
export class TerminalsActionsComponent extends ActionsBase {

  constructor(public managementService: TerminalsService, private router: Router, cdr: ChangeDetectorRef,
    private shopService: ShopService) {
    super(cdr, managementService);
  }

  get routePerson(): boolean {
    return this.router.url.includes("terminals");
  }

  get selectedUser() {
    return this.managementService.getSelectedModel();
  }

  get canDelete(): boolean {
    return true;
  }

  get canCreate(): boolean {
    return true;
  }

  get isAnyWriteable(): boolean {
    return true;
  }

  public addNewPerson() {
    this.managementService.addNewTerminal();
  }

  public savePerson() {
    this.managementService.saveModel();
  }

  public stopEditMode() {
    this.managementService.stopEditMode();
  }

  public discardChanges() {
    this.managementService.discardChanges();
  }

  public isChanged() {
    return this.managementService.isModelChanged();
  }

  public isSaveable() {
    return this.managementService.isModelSaveable();
  }

  public deleteTerminalQuestion() {
    this.managementService.deleteModelQuestion();
  }

  public showError() {
    this.managementService.showFormularError();
  }

  public get isFormularValid() {
    return this.managementService.isFormularValid;
  }

  public get isBackdropOkay() {
    return this.managementService.isBackdropOkay();
  }

  public cancel() {
    this.stopEditMode();
    this.discardChanges();
  }

  public get isEditMode(): boolean {
    return this.managementService.isEditMode;
  }

  public get isTerminalSelected(): boolean {
    return this.managementService.isModelSelected();
  }

  public startEditMode() {
    this.managementService.startEditMode();
  }

  public updateData() {
    this.managementService.updateTerminals();
    this.shopService.updateAllShops();
  }

  public uploadUpdate() {
    this.managementService.uploadUpdate();
  }

  public openUpdateProtocol() {
    this.managementService.openUpdateProtocol();
  }

}
